export default __webpack_public_path__ + "static/media/example-logo.e62316af.svg";